import React from 'react';
import { getEscrowStatusOptions } from '../../services/api';

const ActionModal = ({
  actionModal,
  setActionModal,
  modalData,
  setModalData,
  notes,
  setNotes,
  escrow,
  formatEscrowAmount,
  onRelease,
  onRefund,
  onAddNotes,
  onUpdateStatus,
  onAdjustFees
}) => {
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-gray-800 rounded-xl border border-gray-700 w-full max-w-md">
        <div className="p-6 border-b border-gray-700">
          <h3 className="text-lg font-semibold text-white">
            {actionModal === 'release' && 'Release Funds to Seller'}
            {actionModal === 'refund' && 'Refund Funds to Buyer'}
            {actionModal === 'notes' && 'Add Admin Notes'}
            {actionModal === 'status' && 'Update Escrow Status'}
            {actionModal === 'fees' && 'Adjust Fee Breakdown'}
          </h3>
        </div>

        <div className="p-6">
          {actionModal === 'release' && (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Amount to Release
                </label>
                <input
                  type="number"
                  value={modalData.amount || escrow?.amount}
                  onChange={(e) => setModalData({...modalData, amount: e.target.value})}
                  className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent text-white"
                  placeholder="Enter amount"
                />
                <p className="text-xs text-gray-400 mt-1">
                  Maximum: {formatEscrowAmount(escrow?.amount)}
                </p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Admin Notes (Optional)
                </label>
                <textarea
                  value={modalData.notes || ''}
                  onChange={(e) => setModalData({...modalData, notes: e.target.value})}
                  className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent text-white"
                  rows="3"
                  placeholder="Add notes about this release"
                />
              </div>
              {escrow?.status === 'disputed' && (
                <div className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    id="force"
                    checked={modalData.force || false}
                    onChange={(e) => setModalData({...modalData, force: e.target.checked})}
                    className="rounded border-gray-600 bg-gray-700 text-[#ff660e]"
                  />
                  <label htmlFor="force" className="text-sm text-gray-300">
                    Force release (bypass dispute)
                  </label>
                </div>
              )}
            </div>
          )}

          {actionModal === 'refund' && (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Amount to Refund
                </label>
                <input
                  type="number"
                  value={modalData.amount || escrow?.amount}
                  onChange={(e) => setModalData({...modalData, amount: e.target.value})}
                  className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent text-white"
                  placeholder="Enter amount"
                />
                <p className="text-xs text-gray-400 mt-1">
                  Maximum: {formatEscrowAmount(escrow?.amount)}
                </p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Admin Notes (Optional)
                </label>
                <textarea
                  value={modalData.notes || ''}
                  onChange={(e) => setModalData({...modalData, notes: e.target.value})}
                  className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent text-white"
                  rows="3"
                  placeholder="Add notes about this refund"
                />
              </div>
              {escrow?.status === 'disputed' && (
                <div className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    id="force"
                    checked={modalData.force || false}
                    onChange={(e) => setModalData({...modalData, force: e.target.checked})}
                    className="rounded border-gray-600 bg-gray-700 text-[#ff660e]"
                  />
                  <label htmlFor="force" className="text-sm text-gray-300">
                    Force refund (bypass dispute)
                  </label>
                </div>
              )}
            </div>
          )}

          {actionModal === 'notes' && (
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Admin Notes
              </label>
              <textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent text-white"
                rows="4"
                placeholder="Add your notes here..."
              />
            </div>
          )}

          {actionModal === 'status' && (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  New Status
                </label>
                <select
                  value={modalData.status || ''}
                  onChange={(e) => setModalData({...modalData, status: e.target.value})}
                  className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent text-white"
                >
                  {getEscrowStatusOptions().map(option => (
                    <option key={option.id} value={option.id}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Notes (Optional)
                </label>
                <textarea
                  value={modalData.notes || ''}
                  onChange={(e) => setModalData({...modalData, notes: e.target.value})}
                  className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent text-white"
                  rows="3"
                  placeholder="Why are you changing the status?"
                />
              </div>
            </div>
          )}

          {actionModal === 'fees' && (
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Platform Fee
                  </label>
                  <input
                    type="number"
                    value={modalData.platform_fee || 0}
                    onChange={(e) => setModalData({...modalData, platform_fee: e.target.value})}
                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent text-white"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Payment Fee
                  </label>
                  <input
                    type="number"
                    value={modalData.paystack_fee || 0}
                    onChange={(e) => setModalData({...modalData, paystack_fee: e.target.value})}
                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent text-white"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Buyer Share
                  </label>
                  <input
                    type="number"
                    value={modalData.buyer_share || 0}
                    onChange={(e) => setModalData({...modalData, buyer_share: e.target.value})}
                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent text-white"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Seller Share
                  </label>
                  <input
                    type="number"
                    value={modalData.seller_share || 0}
                    onChange={(e) => setModalData({...modalData, seller_share: e.target.value})}
                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent text-white"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Seller Receives
                </label>
                <input
                  type="number"
                  value={modalData.seller_receives || 0}
                  onChange={(e) => setModalData({...modalData, seller_receives: e.target.value})}
                  className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Notes (Optional)
                </label>
                <textarea
                  value={modalData.notes || ''}
                  onChange={(e) => setModalData({...modalData, notes: e.target.value})}
                  className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent text-white"
                  rows="2"
                  placeholder="Reason for fee adjustment"
                />
              </div>
            </div>
          )}
        </div>

        <div className="p-6 border-t border-gray-700 flex justify-end space-x-3">
          <button
            onClick={() => setActionModal(null)}
            className="px-4 py-2 text-gray-300 bg-gray-700 border border-gray-600 rounded-lg hover:bg-gray-600 transition-colors font-medium hover:scale-[1.02]"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              if (actionModal === 'release') onRelease();
              else if (actionModal === 'refund') onRefund();
              else if (actionModal === 'notes') onAddNotes();
              else if (actionModal === 'status') onUpdateStatus();
              else if (actionModal === 'fees') onAdjustFees();
            }}
            className="px-4 py-2 bg-gradient-to-r from-[#ff660e] to-orange-500 text-white rounded-lg hover:from-[#ff5500] hover:to-orange-600 transition-colors font-medium flex items-center hover:scale-[1.02]"
          >
            <span className="mr-2">💾</span>
            {actionModal === 'release' && 'Release Funds'}
            {actionModal === 'refund' && 'Refund Funds'}
            {actionModal === 'notes' && 'Save Notes'}
            {actionModal === 'status' && 'Update Status'}
            {actionModal === 'fees' && 'Adjust Fees'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActionModal;